var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#003C71",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 20H0M25 53H5a5 5 0 0 1-5-5V11a5 5 0 0 1 5-5h46a5 5 0 0 1 5 5v20M13 0v12M43 0v12M45.828 43.172l-5.656 5.656M40.172 43.172l5.656 5.656"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 46,
    r: 12
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCreate);
export default __webpack_public_path__ + "static/media/event-create.1375bec1f0fd49d5c13a4fa462285c21.svg";
export { ForwardRef as ReactComponent };